<template>
	<main class="module-box">
		<header class="title-box">
			<img class="title-left" src="../../assets/images/fission/title-left.png" />
			<span class="title-middle">
				<img class="title-frame-sub" src="../../assets/images/fission/title-frame-sub.png" />
				<span class="title">{{ title }}</span>
			</span>
			<img class="title-right" src="../../assets/images/fission/title-right.png" />
		</header>
		<slot></slot>
	</main>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: '标题',
			},
		},
	};
</script>

<style lang="less" scoped>
	.module-box {
		border-radius: 0.12rem;
		background-color: #fff;
		margin-bottom: 0.18rem;
	}
	.title-box {
		position: relative;
		z-index: 2;
		text-align: center;
		img {
			display: inline-block;
			vertical-align: middle;
			margin-top: -0.02rem;
		}
	}
	.title-frame-sub {
		width: 1.64rem;
	}
	.title-left,
	.title-right {
		width: 0.3rem;
	}
	.title-middle {
		position: relative;
		margin: 0 0.14rem;
		white-space: nowrap;
		.title {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			z-index: 2;
			font-size: 0.14rem;
			line-height: 0.21rem;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/ModuleBox.vue